/** Shared Insta Quiz visual theme — purple / magenta live-energy palette */
export const INSTA_QUIZ = {
  purple: '#9C27B0',
  purpleLight: '#CE93D8',
  purpleDark: '#7B1FA2',
  magenta: '#E040FB',
  cyan: '#00E5FF',
  bg: '#0a0a0f',
  card: 'rgba(22, 12, 32, 0.92)',
  cardBorder: 'rgba(156, 39, 176, 0.35)',
  textMuted: 'rgba(255,255,255,0.65)',
};

export const instaQuizPageSx = {
  minHeight: '100vh',
  background:
    'radial-gradient(ellipse 80% 50% at 50% -20%, rgba(156,39,176,0.28) 0%, transparent 55%),' +
    'radial-gradient(ellipse 60% 40% at 100% 100%, rgba(224,64,251,0.12) 0%, transparent 50%),' +
    'radial-gradient(ellipse 50% 30% at 0% 80%, rgba(0,229,255,0.08) 0%, transparent 45%),' +
    'linear-gradient(180deg, #0a0a0f 0%, #120818 50%, #0a0a0f 100%)',
  position: 'relative',
  overflow: 'hidden',
};

export const instaQuizCardSx = {
  width: '100%',
  maxWidth: 720,
  background: INSTA_QUIZ.card,
  backdropFilter: 'blur(20px)',
  borderRadius: '24px',
  border: `1px solid ${INSTA_QUIZ.cardBorder}`,
  boxShadow:
    '0 24px 80px rgba(0,0,0,0.45), 0 0 60px rgba(156,39,176,0.12), inset 0 1px 0 rgba(255,255,255,0.06)',
};

export const instaQuizPrimaryButtonSx = {
  background: 'linear-gradient(135deg, #AB47BC 0%, #9C27B0 50%, #7B1FA2 100%)',
  color: '#fff',
  textTransform: 'none',
  fontWeight: 700,
  fontSize: '1.05rem',
  px: 4,
  py: 1.5,
  borderRadius: '999px',
  boxShadow: '0 8px 32px rgba(156,39,176,0.45)',
  '&:hover': {
    background: 'linear-gradient(135deg, #BA68C8 0%, #AB47BC 50%, #8E24AA 100%)',
    boxShadow: '0 12px 40px rgba(156,39,176,0.55)',
  },
  '&:disabled': {
    background: 'rgba(156,39,176,0.35)',
    color: 'rgba(255,255,255,0.5)',
  },
};
